export default __webpack_public_path__ + "static/KingXL-c025a8c0035101988b42e9ba810204a7.svg";